import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { Outlet } from 'react-router-dom';

import { unloadProject, viewProject } from '../../modules/techModule/project';
import ProjectTemplate from '../../components/techmng/ProjectTemplate';
import ProjectInfoContainer from './info/ProjectInfoContainer';

const ProjectContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { project, error, loading } = useSelector(
    ({ techModule, loading }) => ({
      project: techModule.project.project,
      error: techModule.project.error,
      loading: loading['tech/VIEW_PROJECT'],
    }),
  );

  useEffect(() => {
    dispatch(viewProject(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadProject());
    };
  }, [dispatch, id]);

  const handleGoBack = () => {
    navigate('/techmng');
  };

  return (
    <>
      <ProjectTemplate project={project} loading={loading} error={error}>
        <ProjectInfoContainer handleGoBack={handleGoBack} />
      </ProjectTemplate>
      <Box>
       {project && ( <Outlet />)}
      </Box>
    </>
  );
};

export default ProjectContainer;
